import React from 'react'
import FlightDeals from '../FlightDeals/FlightDeals'
import Text from '../Text/Text'
import Offer from '../Offer/Offer'
import Text2 from '../Text2/Text2'
import News from '../News/News'
import Text3 from '../Test3/Text3'
import Instagram from '../Instagram/Instagram'
import Postermain from '../Postermain/Postermain'
import Swiper from '../Swiper/Swiper'
const Home = () => {
  return (
    <>
    
    <FlightDeals bgClass="bg-home" />
         <Postermain/>
      <Text/>
      {/*-
      <Offer/>
      -*/}
      <Swiper/>
      <Text2/>
      {/*-
      <News/>
     -*/}
  
    
      
      <Text3/>
      {/*-
      <Instagram/>
      -*/}
    </>
  )
}

export default Home